(function() {
  if ('ontouchstart' in window) return;

  const cursor = document.createElement('div');
  cursor.id = 'nlx-cursor';

  const trail = document.createElement('div');
  trail.id = 'nlx-cursor-trail';

  const style = document.createElement('style');
  style.textContent = `
    * { cursor: none !important; }

    #nlx-cursor {
      position: fixed;
      width: 8px;
      height: 8px;
      background: rgba(168, 85, 247, 1);
      border-radius: 50%;
      pointer-events: none;
      z-index: 99999;
      transform: translate(-50%, -50%);
      transition: transform 0.1s ease, background 0.2s ease, width 0.2s ease, height 0.2s ease;
      box-shadow:
        0 0 6px rgba(168, 85, 247, 0.9),
        0 0 12px rgba(168, 85, 247, 0.6),
        0 0 24px rgba(168, 85, 247, 0.3);
      mix-blend-mode: screen;
    }

    #nlx-cursor-trail {
      position: fixed;
      width: 32px;
      height: 32px;
      border: 1px solid rgba(168, 85, 247, 0.4);
      border-radius: 50%;
      pointer-events: none;
      z-index: 99998;
      transform: translate(-50%, -50%);
      transition: left 0.12s ease, top 0.12s ease, width 0.2s ease, height 0.2s ease, border-color 0.2s ease;
      box-shadow: 0 0 8px rgba(168, 85, 247, 0.2);
    }

    #nlx-cursor.clicking {
      width: 12px;
      height: 12px;
      background: rgba(96, 165, 250, 1);
      box-shadow:
        0 0 8px rgba(96, 165, 250, 0.9),
        0 0 20px rgba(96, 165, 250, 0.6),
        0 0 40px rgba(96, 165, 250, 0.3);
    }

    #nlx-cursor-trail.clicking {
      width: 48px;
      height: 48px;
      border-color: rgba(96, 165, 250, 0.5);
    }

    #nlx-cursor.hovering {
      width: 6px;
      height: 6px;
      background: rgba(200, 130, 255, 1);
    }

    #nlx-cursor-trail.hovering {
      width: 48px;
      height: 48px;
      border-color: rgba(200, 130, 255, 0.5);
      box-shadow: 0 0 16px rgba(200, 130, 255, 0.2);
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(cursor);
  document.body.appendChild(trail);

  let mouseX = 0;
  let mouseY = 0;
  let trailX = 0;
  let trailY = 0;

  const particles = [];

  const canvas = document.createElement('canvas');
  canvas.id = 'nlx-cursor-canvas';
  canvas.style.cssText = `
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 99997;
    mix-blend-mode: screen;
  `;
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    cursor.style.left = mouseX + 'px';
    cursor.style.top = mouseY + 'px';

    if (Math.random() < 0.9) {
      particles.push({
        x: mouseX,
        y: mouseY,
        vx: (Math.random() - 0.5) * 1.5,
        vy: (Math.random() - 0.5) * 1.5,
        life: 1,
        decay: 0.02 + Math.random() * 0.02,
        size: 1.5 + Math.random() * 3,
        color: Math.random() < 0.6 ? [168, 85, 247] : [96, 165, 250]
      });
    }
  });

  document.addEventListener('mousedown', () => {
    cursor.classList.add('clicking');
    trail.classList.add('clicking');

    for (let i = 0; i < 20; i++) {
      const angle = (Math.PI * 2 / 20) * i;
      particles.push({
        x: mouseX,
        y: mouseY,
        vx: Math.cos(angle) * (4 + Math.random() * 6),
        vy: Math.sin(angle) * (4 + Math.random() * 6),
        life: 1,
        decay: 0.02 + Math.random() * 0.02,
        size: 2.5 + Math.random() * 3,
        color: [96, 165, 250]
      });
    }
  });

  document.addEventListener('mouseup', () => {
    cursor.classList.remove('clicking');
    trail.classList.remove('clicking');
  });

  const interactiveSelectors = 'a, button, .nlx-product-card, .nlx-service-item, input, [role="button"]';

  document.addEventListener('mouseover', (e) => {
    if (e.target.closest(interactiveSelectors)) {
      cursor.classList.add('hovering');
      trail.classList.add('hovering');
    }
  });

  document.addEventListener('mouseout', (e) => {
    if (e.target.closest(interactiveSelectors)) {
      cursor.classList.remove('hovering');
      trail.classList.remove('hovering');
    }
  });

  function animateTrail() {
    trailX += (mouseX - trailX) * 0.15;
    trailY += (mouseY - trailY) * 0.15;
    trail.style.left = trailX + 'px';
    trail.style.top = trailY + 'px';

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vx *= 0.96;
      p.vy *= 0.96;
      p.life -= p.decay;

      if (p.life <= 0) {
        particles.splice(i, 1);
        continue;
      }

      const [r, g, b] = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * p.life, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${r},${g},${b},${p.life * 0.8})`;
      ctx.fill();

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * p.life * 3, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${r},${g},${b},${p.life * 0.1})`;
      ctx.fill();
    }

    requestAnimationFrame(animateTrail);
  }

  animateTrail();
})();
